import {
    COUNTRIES_RECEIVE,
    SUPPORT_TYPES_RECEIVE,
    RECEIVE_ERROR,
    SUPPORT_CLAIMS_CATEGORIES_RECEIVE,
    CONTACT_FORM_SENT_RECEIVE,
} from '../Actions/Contact.action'
import { error as errorReducer } from './Error.reducer'

const defaultState = {
    countries: [],
    supportTypes: [],
    claimCategories: [],
    errors: {},
}

export const contact = (state = defaultState, action) => {
    switch (action.type) {
        case COUNTRIES_RECEIVE:
            return {
                ...state,
                ...action.payload,
            }
        case SUPPORT_TYPES_RECEIVE:
            return {
                ...state,
                ...action.payload,
            }
        case SUPPORT_CLAIMS_CATEGORIES_RECEIVE:
            return {
                ...state,
                ...action.payload,
            }
        case CONTACT_FORM_SENT_RECEIVE:
            return {
                ...state,
                ...action.payload,
            }
        case RECEIVE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            }

        default:
            return state
    }
}
